import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px 24px',
    gridTemplateAreas: '"input1" "select1" "select2" "subject" "input2" "input3"',
    gridTemplateColumns: '100%',
    '@media (max-width: 600px)': {
        gridTemplateColumns: '100%',
        gridGap: '16px',
    },
});
